import { isMobile } from "react-device-detect"
import { RiInformationFill } from "react-icons/ri"
import { Tooltip } from "react-tooltip"
import { RetailerColumnNames } from "../../constants"
import ImageTagsDetails from "../SocialTrendsTags/ImageTagsDetails"
import Collection from "../V2Leaderboard/Collection"
import showFloatToPercentage from "../V2Leaderboard/Utils/showFloatToPercentage";
import roundtocloses0_5_value from "../V2Leaderboard/Utils/roundToClosest_0_5";
import { useSelector } from "react-redux"

const DesignRecipeImage = ({ image, index, gender, category, type, isBoth, allCollectionNames, addImageToCollection, collectionSets, fetchCollections, setLightBoxImageIndex, futureForecastDateString, pastForecastDateString }) => {
  const userLoggedIn = useSelector(state => state.userLoggedIn)

  return <div className={isBoth ? 'w-full lg:w-[24%]' : 'w-1/2 lg:w-[12%]'}>

    <div className=" p-2 border border-slate-300 ">
      <div className="flex justify-center items-center relative group">
        <div className="relative group " >
          <Collection image={image} collections={allCollectionNames} addImageToCollection={addImageToCollection} collectionSets={collectionSets} fetchCollections={fetchCollections} />
          <div >
            <div
              className="absolute bottom-1 left-1 text-lg rounded-full -p-1"
              data-tooltip-id={'trends-tooltip-' + (type == 'social' ? image.mediaId : image.pk)}
              hidden={gender != "F" || gender != 'F' && category == 'Ethinic Wear' || !image.silhouetteTrends || image.silhouetteTrends.length == 0
              }>
              <RiInformationFill color="#333" />
            </div>
            <img
              src={image[type == 'social' ? 'imageUrl' : 'image_url']}
              className='h-40 lg:h-60'
              onClick={() => {
                if (setLightBoxImageIndex)
                  setLightBoxImageIndex(index)
              }}
            />
          </div>
          {gender == 'F' && category != 'Ethinic Wear' && image.silhouetteTrends && image.silhouetteTrends.length > 0 ? <Tooltip
            id={'trends-tooltip-' + (type == 'social' ? image.mediaId : image.pk)}
            style={{ zIndex: 1100 }}
            openEvents={{ click: true }}
          >
            <div className="text-[10px] font-light lg:w-[25rem] max-w-[75vw]">
              <h3 className="text-center">Trends of image</h3>
              <div className="flex justify-between py-1 text-xs">
                <div className={`px-2 text-yellow-500 font-semibold text-wrap shrink-0`}>{Math.ceil(1000 * (image.socialAggregateRateOfGrowth || image.aggregateRateOfGrowth || 0)) / 10} Sum ROG(social)</div>
              </div>
              <div className="ml-2">{
                image.silhouetteTrends//.sort((a, b) => b.success - a.success)
                  .map(sil => <div key={sil.silhouette}>
                    <table className="table-auto w-full table">
                      <thead>
                        <tr>
                          <td>
                            <div>{sil.silhouette}</div>
                          </td>
                          <td>
                            {type == 'social' ? <div className="px-2 text-yellow-500  font-semibold">{Math.ceil(1000 * (sil.aggregateRateOfGrowth || 0)) / 10} Sum ROG(social)</div> : <>
                              <div className="px-2 text-yellow-500 font-semibold w-20 text-wrap shrink-0">{Math.ceil(1000 * (sil.socialAggregateRateOfGrowth || 0)) / 10} Sum ROG(social)</div>
                              {false ? <div className="px-2 w-20 shrink-0 text-wrap">{Math.ceil(1000 * (sil.aggregateRateOfGrowth || 0)) / 10} Sum ROG(retailer)</div> : null}
                            </>}
                          </td>
                          <td>
                            {false ? <div>{sil.success} Success points</div> : null}
                          </td>

                        </tr>
                      </thead>
                      <tbody>
                        {sil.trends.map(trend => <tr >
                          <td>
                            <p className="text-wrap pr-2">{trend.primaryTagValue} <span className="font-semibold">x</span> {trend.secondaryValue}</p>
                          </td>
                          <td>
                            {
                              type == 'social' ? <p className="px-2  text-yellow-500 font-semibold">{Math.ceil((trend.rateOfGrowth || 0) * 1000) / 10}%</p> : <>
                                <p className="px-2 text-yellow-500 font-semibold">{Math.ceil((trend.socialRateOfGrowth || 0) * 1000) / 10}%</p>
                                {false ? <p className="px-2">{Math.ceil((trend.rateOfGrowth || 0) * 1000) / 10}%</p> : null}
                              </>
                            }
                          </td>
                          <td>
                            <p>{trend.lifecycle}</p>
                          </td>
                        </tr >)}
                      </tbody>
                    </table>
                  </div>)


              }
              </div>

            </div>
          </Tooltip> : null}

          {category != 'All' ? <Tooltip
            id={'forecast-tooltip-' + (type == 'social' ? image.mediaId : image.pk)}
            style={{ zIndex: 1100 }}
          >
            <div className="text-[10px] font-light  max-w-[75vw]">
              <h3 className="text-center">Forecast of image trends </h3>
              <div className="flex justify-between py-1 text-xs">
                <div className={`px-2 text-yellow-500 font-semibold text-wrap shrink-0`}>Forecast score of image </div><div>{Math.ceil(1000 * (image.forecastScoreOfCategory || 0)) / 10} </div>
              </div>
              <div className="ml-2">{
                image.categoryTrends && image.categoryTrends.trends ? <table className="table-auto w-full table">
                  <thead>
                    <tr className="border-b-[0.2px] border-b-white">
                      <th className="px-2">Trend</th>
                      <td className="px-2">Forecast </td>
                      <td className="px-2">-45 days Forecast</td>
                    </tr>
                  </thead>
                  <tbody>
                    {image.categoryTrends.trends
                      .sort((a, b) => (b.forecastShare - a.forecastShare)).map(trend => <tr >
                        <td><p className="text-wrap pr-2">{trend.tag} <span className="font-semibold">x</span> {trend.value}</p></td>
                        <td className="text-center">{roundtocloses0_5_value(showFloatToPercentage(trend.forecastShare))}</td>
                        <td className="text-center">{roundtocloses0_5_value(showFloatToPercentage(trend.depth))}</td>
                      </tr >)}
                  </tbody>
                </table>
                  : null

              }
              </div>

            </div>
          </Tooltip> : null}
        </div>
      </div>
      {
        image.trends && image.trends[0] && image.trends ? <div>
          {[...new Set(image.trends.map(t => t.primaryTagValue)).values()].map(val => <p className="text-xs px-3 font-bold" key={val}>{val}</p>)}
        </div> : null
      }
      {
        type == 'social' ? <div className="px-3 text-xs">
          <a href={`${image.postUrl}`} className='text-blue-600 font-medium' target='_blank'>{image.username}</a>
          <p>{new Date(image.timeStamp).toDateString()}</p>
          <ImageTagsDetails mediaId={image.mediaId} />
        </div> : <div className="px-3 text-xs">

          {['sales', 'reviews', 'bestsellerRank', 'retailerHashtag'].map(item => <div key={item} hidden={!image[item]} className=' max-w-40 text-[12px] font-normal'><span className="font-semibold">{RetailerColumnNames[item]}: </span>{image[item]}</div>)}
          <a href={`${image.product_url}`} className='text-blue-600 font-medium' target='_blank'>{image.retailer || 'Product'}</a>
          {['brand', 'price', 'title'].map(item => <div key={item} hidden={!image[item]} className={`${item == 'title' ? 'text-nowrap overflow-hidden' : ''} max-w-40 text-[12px]`}><span className="font-semibold">{RetailerColumnNames[item]}: </span>{item == 'title' ? image[item].slice(0, 20) : image[item]}</div>)}
          <ImageTagsDetails mediaId={image.pk} isretailer={true} />
        </div>
      }

      {image.forecastScoreOfCategory > 0 ? <div
        className="text-[10.5px] px-2 "
        data-tooltip-id={'forecast-tooltip-' + (type == 'social' ? image.mediaId : image.pk)}
        hidden={category == "All"}
      >
        <p>Past DF score ({pastForecastDateString}) was {roundtocloses0_5_value(showFloatToPercentage(image.forecastScoreOfCategory))}</p>
        <p>Future DF score ({futureForecastDateString}) is {roundtocloses0_5_value(showFloatToPercentage(image.oldForecastScoreOfCategory))}</p>
      </div> : null}
    </div>
  </div >
}

export default DesignRecipeImage
